import { ECommercialOwnershipVerificationFormViewFields, EIdentificationPersonTypeNone } from '../../enums';
import { TCommercialOwnershipVerificationFormViewState } from '../../types';

import { fieldsByType } from '../maps';

export const areAllFieldsRequiredFilled = (
  formState: Partial<TCommercialOwnershipVerificationFormViewState>,
): boolean => {
  const identificationPersonType =
    formState[ECommercialOwnershipVerificationFormViewFields.IdentificationPersonType]?.value ||
    EIdentificationPersonTypeNone.None;

  const requiredFields = fieldsByType[identificationPersonType].require;

  return requiredFields.every(field => formState[field]?.value && !formState[field]?.errorMessage);
};
